import Vue from 'vue';
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import VModal from 'vue-js-modal';
import VTooltip from 'v-tooltip';
import vClickOutside from 'v-click-outside';
import VueSlider from 'vue-slider-component';
import DateRangePicker from 'vue-mj-daterangepicker';
import VueFlashMessage from 'vue-flash-message';
import Paginate from 'vuejs-paginate';
import vueResponsive from 'vue-responsive';
import moment from 'moment';
import App from './App.vue';
import router from './router';
import store from './store';
import { Time, Date } from './filters/date';
import Pluralize from './filters/pluralize';
import { i18n } from './plugins/i18n';

Vue.config.productionTip = false;

Vue.prototype.moment = moment;

const requireComponent = require.context('./components', false, /Base[A-Z]\w+\.(vue|js)$/);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, ''),
    ),
  );
  Vue.component(componentName, componentConfig.default || componentConfig);
});


Vue.component('VueSlider', VueSlider);
Vue.component('paginate', Paginate);
Vue.filter('time', Time);
Vue.filter('date', Date);
Vue.filter('pluralize', Pluralize);
Vue.use(vueResponsive);
Vue.use(DateRangePicker);
Vue.use(VModal, { dynamic: true });
Vue.use(VTooltip);
Vue.use(vClickOutside);
Vue.use(VueFlashMessage, {
  messageOptions: {
    timeout: 4000,
  },
});


new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
